var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 33,
    viewBox: "0 0 43 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.4091V23.1364C0 20.4697 0.5 17.697 1.5 14.8182C2.5303 11.9091 3.92424 9.16667 5.68182 6.59091C7.4697 3.98485 9.4697 1.78788 11.6818 0L19.3182 4.95454C17.5303 7.65152 16.0303 10.4697 14.8182 13.4091C13.6364 16.3182 13.0606 19.5303 13.0909 23.0455V32.4091H0ZM23.0455 32.4091V23.1364C23.0455 20.4697 23.5455 17.697 24.5455 14.8182C25.5758 11.9091 26.9697 9.16667 28.7273 6.59091C30.5152 3.98485 32.5152 1.78788 34.7273 0L42.3636 4.95454C40.5758 7.65152 39.0758 10.4697 37.8636 13.4091C36.6818 16.3182 36.1061 19.5303 36.1364 23.0455V32.4091H23.0455Z",
    fill: "#972682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.268b7f1c44946635445e7a447de4f1f7.svg";
export { ForwardRef as ReactComponent };